export class ClassificationFieldTranslation {

  public name: string;
  public languageCode: string;

}
